<style scoped>
    hr {
        margin-top: 5px;
        margin-bottom: 5px;
    }
</style>

<template>
    <div>
        

        <div class="col-md-12">
            <transition name="fade" :duration="1000">
                <div v-show="loading" class="col-md-12 col-md-offset-5" style="position:absolute; top:0">
                    <br /><br /><br />
                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
                    <span class="sr-only">Loading...</span>
                </div>
            </transition>
            <div v-if="!loading">

                <div>
                    <ul class="nav nav-pills">
                        <li class="disabled"><h3 style="margin:0px" class="text-primary"><em>{{carehomeDto.name}}</em></h3></li>
                        <li class="pull-right">
                            <a href="#" class="btn btn-link" @click.prevent.self="CreateUser">Add User</a>
                        </li>
                    </ul>
                    <hr />
                </div>

                <carehome-user-table :id="carehomeid" v-model="selectedUser"></carehome-user-table>
                <br />
            </div>
        </div>
    </div>
</template>
<script>

    import { CarehomeDto } from './../../../dto/carehomedto'
    import Dal from './../../../scripts/dataaccess'

    import CarehomeHeader from './../../appcontrols/CarehomeHeader/CarehomeHeader.scp.html'
    import CarehomeUserTable from './../../appcontrols/carehomeusertable/carehomeusertable.scp.html'

    export default {
        props: ['carehomeid'],
        data: function () {
            return {
                loading: true,
                carehomeid: "",
                carehomeDto: null,
                selectedUser: {}
            }
        },
        watch: {
            'selectedUser': function (user) {
                // User clicked - navigate to edit user
                console.log(user.email)
                //this.$router.push({ name: 'pharmacy-carehome-user-edit', query: { 'carehomeid': this.carehomeid, 'userid': user.id } })
                this.UpdateUser(user.id)
            }
        },
        mounted: function () {

            var dal = new Dal();
            dal.GetCarehome(this.carehomeid).then(data => {
                this.carehomeDto = data;
                this.loading = false;
            });
        },
        methods: {
            CreateUser: function () {
                this.$router.push({ name: 'pharmacy-carehome-user-edit', query: { 'carehomeid': this.carehomeid  } })
            },
            UpdateUser: function (userid) {
                this.$router.push({ name: 'pharmacy-carehome-user-edit', query: { 'carehomeid': this.carehomeid, 'userid': userid } })
            }
        },
        components: {
            CarehomeHeader,
            CarehomeUserTable
        }
    }

</script>


// WEBPACK FOOTER //
// carehome-users.scp.html?30df3a80